//接口请求映射  钢铁 1  环保 2 智能 3 城市 4
export const industryTypeMap={
  steel:1,
  energy:2,
  intelligent:3,
  urban:4
}

//行业领域标题映射
export const industryTitleMap={
  steel:'冶金技术',
  energy:'能源环保',
  intelligent:'数字智能',
  urban:'产城融合'
}


//埋点映射
export const moduleTypeMap={
  steel:{
    policy:1,
    news:2,
    paper:3,
    patent:4
  },
  energy:{
    policy:5,
    news:6,
    paper:7,
    patent:8
  },
  intelligent:{
    policy:9,
    news:10,
    paper:11,
    patent:12
  },
  urban:{
    policy:22,
    news:23,
    paper:24,
    patent:25
  }
}